import { css } from '@/styled-system/css';
import { token } from '@/styled-system/tokens';
import { SRP_CONTENT_PANEL_MAX_WIDTH } from '@/src/layouts/persistentSearchLayout.constants';

const MOBILE_HEADER_HEIGHT = token('sizes.1200');

export const detailHubContainer = css({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'bg.neutral',
  position: 'relative',
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': {
    minHeight: '100dvh',
  },
  lg: {
    minHeight: 'unset',
  },
});

export const detailHeader = css({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingInline: 'default',
  paddingBlock: 'default',
  minHeight: MOBILE_HEADER_HEIGHT,
  backgroundColor: 'transparent',
  zIndex: 'zIndexOverParent',
  lg: {
    display: 'none',
  },
});

export const headerActions = css({
  display: 'flex',
  gap: 'default',
  alignItems: 'center',
});

export const detailMainContent = css({
  flex: 1,
  position: 'relative',
  lg: {
    display: 'flex',
    flexDirection: 'column',
  },
});

// Body surface for the route-native HDP. Document scroll owns the page; the
// desktop map stays sticky beside it in the shared search shell.
export const detailScrollArea = css({
  lg: {
    scrollbarGutter: 'stable',
  },
});

export const detailBody = css({
  width: '100%',
});

export const detailFooter = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'tighter',
  padding: 'default',
  backgroundColor: 'bg.neutral',
  borderTopWidth: 'default',
  borderTopStyle: 'solid',
  borderTopColor: 'border.neutral',
  minHeight: '1800',
  position: 'sticky',
  bottom: 0,
  zIndex: 'zIndexStep',
  lg: {
    display: 'none',
  },
});

export const spokeFooterActions = css({
  display: 'flex',
  gap: 'tighter',
  width: '100%',
  // eslint-disable-next-line hotpads/no-magic-numbers -- caps sticky footer CTAs to the designed mobile button group width
  maxWidth: '400px',
});

export const desktopFloatingFooter = css({
  display: 'none',
  lg: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    right: 'default',
    bottom: 'loose',
    width: '50vw',
    maxWidth: SRP_CONTENT_PANEL_MAX_WIDTH,
    paddingInline: 'default',
    pointerEvents: 'none',
    zIndex: 'zIndexOverParent',
  },
});

export const desktopFooterSurface = css({
  width: '100%',
  // eslint-disable-next-line hotpads/no-magic-numbers -- matches the designed CTA group width used by the mobile footer
  maxWidth: '400px',
  padding: 'tighter',
  pointerEvents: 'auto',
});

export const desktopFooterActions = css({
  display: 'flex',
  gap: 'tighter',
  width: '100%',
});
